import Window from "../window/Window";

function Contact() {
  function submit(e) {
    /*const url = "https://formspree.io/f/xyyvvzvo";
    e.preventDefault();
    var form = e.target;
    var formData = new FormData(form);
    // const formDataObj = {};
    // formData.forEach((value, key) => (formDataObj[key] = value));
    const obj = {
      method: "POST",
      body: formData,
    //   headers: { "Content-type": "application/json; charset=UTF-8" },
    };
    console.log(formData);
    console.log(obj);
    console.log("----------------------------------------");
    fetch(url, obj)
      .then((response) => response.json())
      .then((json) => console.log(json))
      .catch((err) => console.log(err));*/
  }

  return (
    <Window id="contact" title="Contactez moi">
      <form
        action="https://formspree.io/f/xyyvvzvo"
        method="POST"
      >
      <fieldset>
        <label htmlFor="message">Message</label>
        <textarea name="message" title="message" id="message" required></textarea>
      </fieldset>
        <fieldset>
          <fieldset>
            <label htmlFor="name">Nom</label>
            <input name="name" title="name" id="name" type="text"></input>
            <label htmlFor="email">Email</label>
            <input name="email" title="email" id="email" type="email"></input>
            <label htmlFor="subject">Sujet</label>
            <input
              name="subject"
              title="subject"
              id="subject"
              type="text"
            ></input>
          </fieldset>
          <fieldset>
            <p>Formulaire utilisant <a href="https://formspree.io" target="_blank">https://formspree.io</a></p>
            <p>Utiliser directement mon mail ? <br /> <a href="mailto:vingt-douze@protonmail.com?subject=Mail envoyé depuis le Portfolio">vingt-douze@protonmail.com</a></p>
            <button type="submit">Envoyer</button>
          </fieldset>
        </fieldset>
      </form>
    </Window>
  );
}

export default Contact;
